import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b19c0b0e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b19c0b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19c0b0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b19c0b0e')) {
      api.createRecord('b19c0b0e', component.options)
    } else {
      api.reload('b19c0b0e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b19c0b0e&scoped=true&", function () {
      api.rerender('b19c0b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24kNEcCpC97dY/JS/comp/SearchFilterTokens.vue"
export default component.exports